import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/camera-viewfinder.svg")